<template>

    <div>

        <div class="has-text-right">
            <button class="button is-primary is-small" type="button" @click=" $modal.show('add-tool-modal') "><i class="fas fa-plus"></i><i class="fas fa-wrench"></i> &nbsp; Add Tool</button>
        </div>
        <template>
            <div v-if="xTools.length > 0">
                <table class="table is-fullwidth is-striped is-hoverable pb-3">
                    <thead>
                    <tr>
                        <th>Tool Name</th>
                        <th>Status</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="tool in sortedTools" class="cursor-pointer clickable-tool" @click=" $goTo($prepareRoute(routeShowTool, {'-TOOL-ID-':tool.id})) ">
                            <td>{{ tool.title }}</td>
                            <td>
                                <span v-if="availableStatuses['primary'].includes(tool.status)" class="tag is-success">{{ tool.status }}</span>
                                <span v-else-if="availableStatuses['warning'].includes(tool.status)" class="tag is-warning">{{ tool.status }}</span>
                                <span v-else-if="availableStatuses['danger'].includes(tool.status)" class="tag is-danger">{{ tool.status }}</span>
                                <span v-else class="tag">{{ tool.status }}</span>
                            </td>
                            <td>
                                <span class="cursor-pointer is-primary-on-hover" @click.stop=" viewToolDetails(tool, 'xTools') "><i class="fas fa-info-circle"></i></span>
                                <span class="cursor-pointer is-primary-on-hover" @click.stop=" openEditTool(tool, 'xTools') "><i class="fas fa-pen"></i></span>
                                <span>
                                    <confirm-button
                                        class="button is-text plain-text-button is-danger-on-hover"
                                        @click=" removeTool(tool) "
                                    >
                                        <i class="fas fa-trash"></i>
                                    </confirm-button>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>

                <table class="table is-fullwidth is-striped is-hoverable pb-3">
                    <thead>
                    <tr>
                        <th>Tool Name</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>THERE ARE NO ASSIGNED TOOLS</td>
                        <td>&nbsp;</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>

        <modal
            name="add-tool-modal"
            :adaptive="true"
            :scrollable="true"
            :width="'600px'"
            :max-width="600"
            @closed=" () => {newToolOpened = false; newTool = {}; loadingTools = true; }"
            @opened=" loadTools "
            :height="'auto'">
            <div class="is-padded">
                <button type="button" class="delete is-top-right has-margins-05" aria-label="close tag control window" @click=" $modal.hide('add-tool-modal') "></button>

                <div v-if=" ! newToolOpened ">
                    <h4 class="title is-4">Add Tool</h4>

                    <div v-if=" loadingTools ">
                        <div class="level">
                            <div class="level-item">
                                <half-circle-spinner
                                    :animation-duration="800"
                                    :size="40"
                                    color="#363636"
                                />
                            </div>
                        </div>
                    </div>

                    <div v-if=" ! loadingTools ">

                        <div v-if="allTools.length <= 0" class="has-text-centered pb-3">There are no tools. Please create a new one.</div>

                        <table v-if="allTools.length > 0" class="table is-fullwidth is-striped is-hoverable pb-3">
                            <thead>
                            <tr>
                                <th>Tool Name</th>
                                <th>Status</th>
                                <th>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="tool in sortedAllTools">
                                <td class="cursor-pointer" @click="attachTool(tool)">{{ tool.title }}</td>
                                <td class="cursor-pointer" @click="attachTool(tool)">
                                    <span v-if="availableStatuses['primary'].includes(tool.status)" class="tag is-success">{{ tool.status }}</span>
                                    <span v-else-if="availableStatuses['warning'].includes(tool.status)" class="tag is-warning">{{ tool.status }}</span>
                                    <span v-else-if="availableStatuses['danger'].includes(tool.status)" class="tag is-danger">{{ tool.status }}</span>
                                    <span v-else class="tag">{{ tool.status }}</span>
                                </td>
                                <td>
                                    <span class="cursor-pointer is-primary-on-hover" @click=" viewToolDetails(tool, 'allTools') "><i class="fas fa-info-circle"></i></span>
                                    <span class="cursor-pointer is-primary-on-hover" @click=" openEditTool(tool, 'allTools') "><i class="fas fa-pen"></i></span>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="field">
                            <div class="control">
                                <button class="button" type="button" @click="newToolOpened = true">create new</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="newToolOpened">

                    <h4 class="title is-4">Create New Tool</h4>

                    <div class="field required">
                        <label for="new_title" class="label">Tool Name</label>
                        <div class="control has-icons-left">
                            <xero-input v-model=" newTool.title " name="title" id="new_title" class="input"></xero-input>
                            <span class="icon is-left">
                                <i class="fas fa-tag"></i>
                            </span>
                        </div>
                    </div>

                    <div class="field">
                        <label for="new_desc" class="label">Short Description</label>
                        <div class="control has-icons-left">
                            <xero-input v-model=" newTool.short_description " name="title" id="new_desc" class="input"></xero-input>
                            <span class="icon is-left">
                                <i class="fas fa-quote-left"></i>
                            </span>
                        </div>
                        <p class="help">(optional) A short description for the tool</p>
                    </div>

                    <div class="field required">
                        <label for="new_shop_id" class="label">Current Status</label>
                        <div class="control has-icons-left">
                            <xero-select
                                name="shop_id"
                                id="new_shop_id"
                                :options=" statusOptions "
                                default-option="WORKING"
                                @change="(data) => {newTool.status = data;}"
                            />
                            <span class="icon is-small is-left" v-if=" newTool.status ">
                                <b v-if="availableStatuses['primary'].includes(newTool.status.toUpperCase())" class="dot" style="background-color: #48c78e;"></b>
                                <b v-if="availableStatuses['warning'].includes(newTool.status.toUpperCase())" class="dot" style="background-color: #ffe08a;"></b>
                                <b v-if="availableStatuses['danger'].includes(newTool.status.toUpperCase())" class="dot" style="background-color: #f14668;"></b>
                            </span>
                        </div>
                    </div>

                    <div class="field">
                        <label for="new_body" class="label">Description</label>
                        <div class="control">
                            <xero-wysiwyg type="simple" name="body" id="new_body" classes="textarea" @input="(e) => {newTool.body=e;}"></xero-wysiwyg>
                        </div>
                        <p class="help">(optional) If necessary, you may provide a longer more in depth description of this tool.</p>
                    </div>

                    <div class="level">
                        <div class="level-left">
                            <button class="level-item button is-small" type="button" @click=" newToolOpened = false ">Cancel</button>
                        </div>
                        <div class="level-right">
                            <button class="level-item button is-primary is-small" type="button" @click=" saveTool ">Save</button>
                            <button class="level-item button is-primary is-small" type="button" @click=" saveAndAttachTool ">Save & Attach</button>
                        </div>
                    </div>
                </div>

            </div>
        </modal>

        <modal
            name="view-tool-details"
            :adaptive="true"
            :scrollable="true"
            :width="'400px'"
            :max-width="400"
            @closed=" () => {viewingTool = {}; viewingToolFrom = ''; } "
            :height="'auto'">
            <div class="is-padded">
                <button type="button" class="delete is-top-right has-margins-05" aria-label="close tag control window" @click=" $modal.hide('view-tool-details') "></button>

                <div class="field">
                    <label class="label">Title</label>
                    <div class="control">{{ viewingTool.title }}</div>
                </div>

                <div class="field">
                    <label class="label">Short Description</label>
                    <div class="control">{{ viewingTool.short_description }}</div>
                </div>

                <div class="field">
                    <label class="label">Status</label>
                    <div class="control">
                        <span v-if="availableStatuses['primary'].includes(viewingTool.status)" class="tag is-success is-medium">{{ viewingTool.status }}</span>
                        <span v-else-if="availableStatuses['warning'].includes(viewingTool.status)" class="tag is-warning is-medium">{{ viewingTool.status }}</span>
                        <span v-else-if="availableStatuses['danger'].includes(viewingTool.status)" class="tag is-danger is-medium">{{ viewingTool.status }}</span>
                        <span v-else class="tag is-medium">{{ viewingTool.status }}</span>
                    </div>
                </div>

                <div class="field">
                    <label class="label">Description</label>
                    <div class="control" v-html="viewingTool.body"></div>
                </div>

                <button class="button" type="button" @click=" openEditTool(viewingTool, viewingToolFrom) ">Edit Tool</button>

            </div>
        </modal>

        <modal
            name="editing-tool-modal"
            :adaptive="true"
            :scrollable="true"
            :width="'600px'"
            :max-width="600"
            @closed=" editingTool = {} "
            :height="'auto'">
            <div class="is-padded">
                <button type="button" class="delete is-top-right has-margins-05" aria-label="close tag control window" @click=" $modal.hide('editing-tool-modal') "></button>

                <h4 class="title is-4">Edit Tool</h4>

                <div class="field required">
                    <label for="edit_title" class="label">Tool Name</label>
                    <div class="control has-icons-left">
                        <xero-input v-model=" editingTool.title " name="title" id="edit_title" class="input"></xero-input>
                        <span class="icon is-left">
                                <i class="fas fa-tag"></i>
                            </span>
                    </div>
                </div>

                <div class="field">
                    <label for="edit_desc" class="label">Short Description</label>
                    <div class="control has-icons-left">
                        <xero-input v-model=" editingTool.short_description " name="short_description" id="edit_desc" class="input"></xero-input>
                        <span class="icon is-left">
                                <i class="fas fa-quote-left"></i>
                            </span>
                    </div>
                    <p class="help">(optional) A short description for the tool</p>
                </div>

                <div class="field required">
                    <label for="edit_shop_id" class="label">Current Status</label>
                    <div class="control has-icons-left">
                        <xero-select
                            name="shop_id"
                            id="edit_shop_id"
                            :options=" statusOptions "
                            :default-option=" editingTool.status "
                            @change="(data) => {editingTool.status = data;}"
                        />
                        <span class="icon is-small is-left" v-if=" editingTool.status ">
                            <b v-if="availableStatuses['primary'].includes(editingTool.status.toUpperCase())" class="dot" style="background-color: #48c78e;"></b>
                            <b v-if="availableStatuses['warning'].includes(editingTool.status.toUpperCase())" class="dot" style="background-color: #ffe08a;"></b>
                            <b v-if="availableStatuses['danger'].includes(editingTool.status.toUpperCase())" class="dot" style="background-color: #f14668;"></b>
                        </span>
                    </div>
                </div>

                <div class="field">
                    <label for="edit_body" class="label">Description</label>
                    <div class="control">
                        <xero-wysiwyg type="simple" name="body" id="edit_body" :value="editingTool.body" classes="textarea" @input="(e) => {editingTool.body=e;}"></xero-wysiwyg>
                    </div>
                    <p class="help">(optional) If necessary, you may provide a longer more in depth description of this tool.</p>
                </div>

                <div class="level">
                    <div class="level-left">
                        <button class="level-item button is-small" type="button" @click=" $modal.hide('editing-tool-modal') ">Cancel</button>
                    </div>
                    <div class="level-right">
                        <button class="level-item button is-primary is-small" type="button" @click=" editTool ">Save Changes</button>
                    </div>
                </div>

            </div>
        </modal>

        <div class="xerocraft-loading" v-if=" loading ">
            <div>
                <p>
                    <img :src=" $store.state.assetRoute + '/images/loading.gif' " alt="Loading Icon">
                </p>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'Shop-Tool-Control',
    props: {
        routeGetAllTools: {
            type: String,
            required: true
        },
        routeCreateTool: {
            type: String,
            required: true
        },
        routeEditTool: {
            type: String,
            required: true
        },
        routeAddTool: {
            type: String,
            required: true
        },
        routeRemoveTool: {
            type: String,
            required: true
        },
        routeShowTool: {
            type: String,
            required: true
        },
        tools: {
            type: Array,
            required: false
        },
        availableStatuses: {
            type: Object,
            required: true
        },
    },
    computed: {
        sortedTools() {
            if(this.xTools.length > 0) {
                return this.xTools.sort((a, b) => (a.title > b.title ? 1 : -1))
            } else return [];
        },
        sortedAllTools() {
            if(this.allTools.length > 0) {
                return this.allTools.sort((a, b) => (a.title > b.title ? 1 : -1))
            } else return [];
        },
        statusOptions() {
            if(!this.$isEmptyObject(this.availableStatuses)) {
                let options = {};
                Object.keys(this.availableStatuses).forEach((type) => {
                    this.availableStatuses[type].forEach((status) => {
                        options[status] = status.toLowerCase();
                    });
                });
                return options;
            } else return {};
        }
    },
    data() {
        return {
            loading: false,
            loadingTools: true,
            xTools: [],
            newToolOpened: false,
            newTool: {},
            allTools: [],
            viewingTool: {},
            viewingToolFrom: '',
            editingTool: {},
            editingFrom: ''
        };
    },
    methods: {
        loadTools() {
            this.loadingTools = true;

            this.$http.post(this.routeGetAllTools)
                .then(response => {
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.success === true) {
                        this.allTools = response.data.tools;
                        this.loadingTools = false;
                    } else if (response.data.errors) {
                        this.$store.commit('errors', response.data.errors);
                    } else {
                        this.$store.commit('error', response.data.message);
                    }
                })
                .catch(error => {
                    this.$displayError(error);
                });
        },
        saveAndAttachTool() {
            this.saveTool(true)
        },
        saveTool(attach = false) {
            this.loading = true;

            this.$http.post(this.routeCreateTool,{
                'title': this.newTool.title,
                'short_description': this.newTool.short_description,
                'status': this.newTool.status,
                'body': this.newTool.body,
            })
                .then(response => {
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.loading = false;
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.success === true && response.data.tool) {
                        this.$store.commit('success', 'Tool has been successfully created!');
                        this.allTools.push(response.data.tool);
                        this.newTool = {};
                        if(attach) {
                            this.attachTool(response.data.tool);
                        } else {
                            this.loading = false;
                        }
                    } else if (response.data.errors) {
                        this.loading = false;
                        this.$store.commit('errors', response.data.errors);
                    } else {
                        this.loading = false;
                        this.$store.commit('error', response.data.message);
                    }
                })
                .catch(error => {
                    this.$displayError(error);
                    this.loading = false;
                });
        },
        editTool() {
            this.loading = true;

            this.$http.post(this.$prepareRoute(this.routeEditTool, {'-TOOL-ID-': this.editingTool.id}), {
                'title': this.editingTool.title,
                'short_description': this.editingTool.short_description,
                'status': this.editingTool.status,
                'body': this.editingTool.body,
                '_method': 'PATCH'
            })
                .then(response => {
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.success === true && response.data.tool) {
                        this.$store.commit('success', 'Tool has been successfully updated!');
                        if(this.editingFrom === 'allTools') {
                            let i = this.allTools.findIndex((tool) => tool.id === this.editingTool.id);
                            this.$set(this.allTools, i, response.data.tool);
                        } else if(this.editingFrom === 'xTools') {
                            let i = this.xTools.findIndex((tool) => tool.id === this.editingTool.id);
                            this.$set(this.xTools, i, response.data.tool);
                        }
                        if(!this.$isEmptyObject(this.viewingTool) && this.viewingToolFrom !== '') {
                            this.viewingTool = response.data.tool;
                        }
                        this.editingTool = {};
                        this.editingFrom = '';
                        this.$modal.hide('editing-tool-modal');
                    } else if (response.data.errors) {
                        this.$store.commit('errors', response.data.errors);
                    } else {
                        this.$store.commit('error', response.data.message);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.$displayError(error);
                    this.loading = false;
                });
        },
        attachTool(tool) {
            this.loading = true;

            this.$http.post(this.$prepareRoute(this.routeAddTool, {'-TOOL-ID-': tool.id}))
                .then(response => {
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.success === true) {
                        this.xTools.push(tool);
                        this.$modal.hide('add-tool-modal');
                    } else if (response.data.errors) {
                        this.$store.commit('errors', response.data.errors);
                    } else {
                        this.$store.commit('error', response.data.message);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.$displayError(error);
                    this.loading = false;
                });
        },
        viewToolDetails(tool, viewingToolFrom) {
            this.viewingTool = tool;
            this.viewingToolFrom = viewingToolFrom;
            this.$modal.show('view-tool-details');
        },
        openEditTool(tool, editingFrom) {
            this.editingFrom = editingFrom;
            this.editingTool = JSON.parse(JSON.stringify(tool));
            this.$modal.show('editing-tool-modal');
        },
        removeTool(removeTool) {
            this.loading = true;

            this.$http.post(this.$prepareRoute(this.routeRemoveTool, {'-TOOL-ID-': removeTool.id}), {
                '_method': 'DELETE'
            })
                .then(response => {
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.success === true) {
                        let i = this.xTools.findIndex((tool) => tool.id === removeTool.id);
                        this.xTools.splice(i, 1);
                    } else if (response.data.errors) {
                        this.$store.commit('errors', response.data.errors);
                    } else {
                        this.$store.commit('error', response.data.message);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.$displayError(error);
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.xTools = this.tools;
    }
}
</script>

<style lang="scss" scoped>
    .clickable-tool:hover {
        background: rgba(243, 129, 53, 0.25) !important;
    }
</style>
